<div *ngIf="getIsResidente(); else termosGerais">
  <app-termos-residente></app-termos-residente>
</div>
<ng-template #termosGerais>
  <app-termos-gerais></app-termos-gerais>
</ng-template>
